/* eslint-disable no-underscore-dangle, react/jsx-filename-extension,
react/prop-types, react/no-array-index-key, import/prefer-default-export */
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import { t } from '../../../../modules/infra/i18n';

import { fullName } from '../../../common/helpers/users';
import { CELL_WIDTH_STATUS } from '../constants';

import {
  icon,
  getTimeColumn,
  status,
  getCardInfoColumn,
  getDescriptionColumn,
} from './Shared';
import { ReceiptBarberName, ReceiptTotalCharge, ReceiptCustomer } from './Receipt';
import { SaleBarberName, SaleTotalCharge, SaleCustomer } from './Sale';
import { ITEM_TYPE } from '../../constants';

const isRecurringMembershipItem = selected => selected.type === 'recurring_membership';
const isInitialMembershipItem = selected => selected.itemType === 'membership';
const isMembershipItem = selected => isInitialMembershipItem(selected) || isRecurringMembershipItem(selected);

export const isReceipt = sale => !!sale.items && sale.items.length > 1;
export const isRefunded = sale => !!sale.chargeRefundId;
export const isCharged = selected => !isEmpty(selected.chargeId);
export const canGetReceipt = selected =>
  (!isEmpty(selected) && !isMembershipItem(selected) && isCharged(selected) && selected.shouldShowReceipt);
export const isChargeSale = sale => sale.type === 'charge';
export const isRefundable = selected => !!selected && selected.refundable;
export const isGiftCardItem = item => item && item.itemType === ITEM_TYPE.giftCard;
export const canReassign = selected => !isMembershipItem(selected);
export const isOnlyFullRefund = selected => isChargeSale(selected) || isMembershipItem(selected);

export const getTableColumns = (activeType, isBookingDeposits = false) => (
  [
    {
      expander: true,
      show: false,
    },
    status,
    getTimeColumn(),
    ...(activeType === 'brand' ? [{
      Header: t('register:summary.table.shop_header'),
      headerClassName: 'u-text-left',
      accessor: (d) => {
        const shopNameFromItems = d.items ? d.items[0].shopName : '';
        const shopNameFromRoot = d.shopName || '';

        return shopNameFromItems || shopNameFromRoot;
      },
      id: 'shop',
    }] : []),
    {
      Header: t('register:summary.table.barber_header'),
      headerClassName: 'u-text-left',
      accessor: d => d.barbers || fullName(d.barber, true) || t('register:summary.table.unassigned_sale'),
      Cell: props => (
        isArray(props.value) ? <ReceiptBarberName {...props} /> : <SaleBarberName {...props} />
      ),
      id: 'barber',
      className: 'o-flexbox o-flexbox--content-align-center',
    },
    {
      Header: t('register:summary.table.customer_header'),
      headerClassName: 'u-text-left',
      accessor: d => d.customers || d.customer || t('register:summary.table.unassigned_customer'),
      id: 'customer',
      className: 'o-flexbox o-flexbox--content-align-center',
      Cell: props => (
        isArray(props.value) ? <ReceiptCustomer {...props} /> : <SaleCustomer {...props} />
      ),
    },
    getDescriptionColumn(),
    getCardInfoColumn(),
    {
      Header: t('register:summary.table.total_charge_header'),
      headerClassName: 'u-text-right',
      accessor: 'totalCost',
      id: 'totalCost',
      className: 'u-type--bold o-flexbox o-flexbox--content-align-center o-flexbox--justify-end',
      Cell: props => (
        isReceipt(props.row._original) ? <ReceiptTotalCharge {...props} /> : <SaleTotalCharge {...props} />
      ),
      width: 100,
    },
    icon,
    ...(isBookingDeposits ? [{
      Header: t('register:summary.table.total_deposit_header'),
      headerClassName: 'u-text-right',
      accessor: 'depositAmount',
      id: 'depositAmount',
      className: 'u-type--bold o-flexbox o-flexbox--content-align-center o-flexbox--justify-end',
      Cell: props => (
        isReceipt(props.row._original) ? <ReceiptTotalCharge {...props} /> : <SaleTotalCharge {...props} />
      ),
      width: 100,
    }] : []),
    ...(isBookingDeposits ? [icon] : []),
  ]
);

export const getSubTableColumns = () => (
  [
    {
      expander: true,
      show: false,
    },
    {
      accessor: d => d.barbers || fullName(d.barber, true) || t('register:summary.table.unassigned_sale'),
      Cell: props => (
        isReceipt(props.row._original) ? <ReceiptBarberName {...props} /> : <SaleBarberName {...props} />
      ),
      id: 'barber',
      className: 'o-flexbox o-flexbox--content-align-center',
    },
    {
      Header: t('register:summary.table.customer_header'),
      headerClassName: 'u-text-left',
      accessor: d => d.customer || t('register:summary.table.unassigned_customer'),
      id: 'customer',
      className: 'o-flexbox o-flexbox--content-align-center u-pre-wrap',
      Cell: props => <SaleCustomer value={props.value} />,
    },
    getDescriptionColumn(),
    {
      width: 180,
      Cell: () => null,
    },
    {
      accessor: 'totalCost',
      id: 'totalCost',
      className: 'u-type--bold o-flexbox o-flexbox--content-align-center o-flexbox--justify-end',
      Cell: props => (
        isReceipt(props.row._original) ? <ReceiptTotalCharge {...props} /> : <SaleTotalCharge {...props} />
      ),
      width: 100,
    },
    {
      Cell: () => null,
      width: CELL_WIDTH_STATUS,
    },
  ]
);
